/** ابزار قالب‌بندی اعداد و تاریخ فارسی */

/**
 * تبدیل عدد به رشته با ارقام فارسی و جداکننده هزارگان
 */
export const toFaDigits = (value: number | string): string => {
  const faDigits = '۰۱۲۳۴۵۶۷۸۹'
  return String(value).replace(/[0-9]/g, (d) => faDigits[Number(d)])
}

/**
 * قالب‌بندی عدد با جداکننده هزارگان (اعداد لاتین با کاما)
 */
export const formatNumber = (value: number): string => {
  if (!isFinite(value)) return '۰'
  return new Intl.NumberFormat('en-US').format(Math.round(value))
}

/**
 * قالب‌بندی عدد با ارقام و جداکننده فارسی
 */
export const formatNumberFa = (value: number): string => {
  if (!isFinite(value)) return '۰'
  return new Intl.NumberFormat('fa-IR').format(Math.round(value))
}

/**
 * قیمت‌ها در دیتابیس به «ریال» ذخیره می‌شوند؛ این تابع برای نمایش عمومی به «تومان» تبدیل می‌کند.
 */
export const toToman = (irrValue: number): number => {
  return Math.round(irrValue / 10)
}

/**
 * نمایش قیمت به تومان با اعداد فارسی
 */
export const formatToman = (irrValue: number): string => {
  return `${toFaDigits(formatNumber(toToman(irrValue)))} تومان`
}

/**
 * نمایش قیمت به ریال (برای مواردی که نیاز است واحد دقیق باشد)
 */
export const formatRial = (irrValue: number): string => {
  return `${toFaDigits(formatNumber(irrValue))} ریال`
}

/**
 * نمایش تاریخ به شمسی
 */
export const formatDateFa = (date: string | Date): string => {
  try {
    const d = new Date(date)
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(d)
  } catch {
    return ''
  }
}

/**
 * نمایش تاریخ و ساعت به شمسی
 */
export const formatDateTimeFa = (date: string | Date): string => {
  try {
    const d = new Date(date)
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(d)
  } catch {
    return ''
  }
}